var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotPinging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_17169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7143 18.8049C45.1048 18.8049 44.5714 18.5763 44.1143 18.1191C32.9905 6.99533 15.0095 6.99533 3.88571 18.1191C2.97143 19.0334 1.52381 19.0334 0.685714 18.1191C-0.228571 17.2049 -0.228571 15.7572 0.685714 14.9191C13.5619 1.96676 34.4381 1.96676 47.3143 14.843C48.2286 15.7572 48.2286 17.2049 47.3143 18.043C46.9333 18.5763 46.3238 18.8049 45.7143 18.8049Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7143 26.8812C37.1048 26.8812 36.5714 26.6526 36.1143 26.1955C29.4095 19.4907 18.5905 19.4907 11.8857 26.1955C10.9714 27.1098 9.52381 27.1098 8.68571 26.1955C7.77143 25.2812 7.77143 23.8336 8.68571 22.9955C17.1429 14.4622 30.8571 14.4622 39.3143 22.9193C40.2286 23.8336 40.2286 25.2812 39.3143 26.1193C38.8571 26.6526 38.3238 26.8812 37.7143 26.8812Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4876 34.4992C28.8781 34.4992 28.3448 34.2706 27.8876 33.8135C25.7543 31.6802 22.2495 31.6802 20.1162 33.8135C19.2019 34.7278 17.7543 34.7278 16.9162 33.8135C16.0019 32.8992 16.0019 31.4516 16.9162 30.6135C20.8019 26.7278 27.2019 26.7278 31.0876 30.6135C32.0019 31.5278 32.0019 32.9754 31.0876 33.8135C30.6305 34.2706 30.0971 34.4992 29.4876 34.4992Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.687574 17.4325C0.611384 17.5087 0.459003 17.6611 0.382812 17.8135C0.459003 17.9659 0.535193 18.0421 0.687574 18.1944C1.60186 19.1087 3.04948 19.1087 3.88757 18.1944C15.0114 7.07063 32.9923 7.07063 44.1161 18.1944C44.5733 18.6516 45.1828 18.8802 45.7161 18.8802C46.2495 18.8802 46.859 18.6516 47.3161 18.1944C47.3923 18.1182 47.5447 17.9659 47.6209 17.8135C47.5447 17.6611 47.4685 17.5849 47.3161 17.4325C34.44 4.55634 13.5638 4.55634 0.687574 17.4325Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68757 25.5089C8.61138 25.5851 8.459 25.7374 8.38281 25.8898C8.459 26.0422 8.53519 26.1184 8.68757 26.2708C9.60186 27.1851 11.0495 27.1851 11.8876 26.2708C18.5923 19.566 29.4114 19.566 36.1161 26.2708C36.5733 26.7279 37.1828 26.9565 37.7161 26.9565C38.2495 26.9565 38.859 26.7279 39.3161 26.2708C39.3923 26.1946 39.5447 26.0422 39.6209 25.8898C39.5447 25.7374 39.4685 25.6613 39.3161 25.5089C30.859 17.0517 17.1447 17.0517 8.68757 25.5089Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.918 33.1272C16.8419 33.2034 16.6895 33.3557 16.6133 33.5081C16.6895 33.6605 16.7657 33.7367 16.918 33.8891C17.8323 34.8034 19.2799 34.8034 20.118 33.8891C22.2514 31.7557 25.7561 31.7557 27.8895 33.8891C28.3466 34.3462 28.9561 34.5748 29.4895 34.5748C30.0228 34.5748 30.6323 34.3462 31.0895 33.8891C31.1657 33.8129 31.318 33.6605 31.3942 33.5081C31.318 33.3557 31.2419 33.2796 31.0895 33.1272C27.2038 29.2415 20.8038 29.2415 16.918 33.1272Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 40.5,
    r: 2.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 21,
    r: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8464 21.1534L44.6077 18.364C44.9529 18.0154 45.298 17.318 45.298 16.795C45.298 16.272 45.1254 15.749 44.6077 15.226C43.7448 14.3543 42.3642 14.3543 41.6739 15.226L38.9126 18.0154L36.1513 15.226C35.2884 14.3543 33.9078 14.3543 33.2175 15.226C32.3546 16.0977 32.3546 17.4924 33.2175 18.1897L35.9787 20.979L33.2175 23.7684C32.3546 24.6401 32.3546 26.0347 33.2175 26.7321C34.0804 27.6037 35.461 27.6037 36.1513 26.7321L38.9126 23.9427L41.6739 26.7321C42.019 27.0807 42.7093 27.4294 43.2271 27.4294C43.7448 27.4294 44.2625 27.2551 44.7803 26.7321C45.6432 25.8604 45.6432 24.4657 44.7803 23.7684L41.8464 21.1534Z",
    fill: "#F4C330"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_17169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPinging);
export default __webpack_public_path__ + "static/media/NotPinging.1daec8e542017e27b7410c456962c8ab.svg";
export { ForwardRef as ReactComponent };